import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=5a6398ca&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=ts&"
export * from "./Captcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6398ca",
  null
  
)

export default component.exports